<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Safety Management"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Safety Management
                    </h2>
                    <p>
                        작업자 안전을 위한 산업 보건 및 안전 관리 경영시스템을 구축했으며, <br class="d-none d-md-block">
                        ISO 45001 : 2018 안전보건 경영시스템 취득 및 사내 산업안전보건 시스템 최신화
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="안전 관리 시스템">
                    <v-img src="/images/sub/wwd/management/management-img.png" max-width="950" class="mx-auto mb-90 mb-md-120 mb-lg-140 d-none d-lg-block"></v-img>
                    <v-img src="/images/sub/wwd/management/management-img-mo.png" max-width="480" class="mx-auto mb-90 mb-md-120 mb-lg-140 d-block d-lg-none"></v-img>
                    <v-row class="my-n10 my-lg-n40">

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon1.png"
                        iconWidth="50"
                        tit="안전보건 관리 체계 구축 및 유지">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                기업의 안전보건 조직 및 재해현황, 업종, 규모, 공정 특성에 <br class="d-none d-lg-block">
                                따른 매뉴얼 숙지 및 안전보건관리체계 구축에 따른 파악 및 이행
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon2.png"
                        iconWidth="53"
                        tit="자율적 산업 재해 예방">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                근로자가 안전보건에 관한 의견 제시 현장의 위험요인 파악, 개선계획 수립, <br class="d-none d-lg-block">
                                근로자 제안 운영 등 참여 여부 확인
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon3.png"
                        iconWidth="51"
                        tit="안전보건 교육훈련">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                근로자의 안전을 위한 안전보건관리 체계 교육 현장의 위험요인 파악을 <br class="d-none d-lg-block">
                                위한 항목들을 파악 조치 운선순위 결정, 통제 및 제어방안 수립
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon4.png"
                        iconWidth="54"
                        tit="안전보건 관련 법규 요구 사항 준수">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                중대재해 처벌법 및 안전보건관리체계 구축 목적, 핵심요소, <br class="d-none d-lg-block">
                                이행 필요성에 따른 핵심 요소별 업무절차 수립 및 이행
                            </p>
                        </sub-icon-box>

                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubIconBox from "@/components/client/ko/sub/sub-icon-box.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubIconBox,
    },
};
</script>

<style lang="scss" scoped>
</style>